import React, { useState } from 'react';
import './App.css';
import ProfilePage from './components/ProfilePage';
import DatingCanvas from './components/DatingCanvas';
import { ProfileCard } from './types';

// Basic JS test - if this doesn't show, JavaScript isn't running at all
console.log('🚨 CRITICAL TEST: App.tsx loaded - JavaScript is working!');

const App: React.FC = () => {
  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState<ProfileCard | null>(null);
  const [initialText, setInitialText] = useState<string>('');
  
  const openCanvas = (card?: ProfileCard) => {
    setSelectedCard(card || null);
    setInitialText('');
    setIsCanvasOpen(true);
  };

  const openCanvasWithText = (text: string) => {
    console.log('App: openCanvasWithText called with:', text);
    setSelectedCard(null);
    setInitialText(text);
    setIsCanvasOpen(true);
    console.log('App: State set - initialText:', text, 'isCanvasOpen:', true);
  };

  const closeCanvas = () => {
    setIsCanvasOpen(false);
    setSelectedCard(null);
    setInitialText('');
  };

  console.log('App: Rendering with isCanvasOpen:', isCanvasOpen, 'selectedCard:', selectedCard, 'initialText:', initialText);
  
  return (
    <div className="App">
      {isCanvasOpen ? (
        <DatingCanvas 
          selectedCard={selectedCard} 
          onClose={closeCanvas}
          initialText={initialText}
        />
      ) : (
        <ProfilePage 
          onOpenCanvas={openCanvas} 
          onOpenCanvasWithText={openCanvasWithText}
        />
      )}
    </div>
  );
};

export default App;